import React from 'react';
import styled from 'styled-components';
import { Column } from '~common/components/column.component';
import { Span } from '~common/components/span.component';
import { Title } from '~common/components/title.component';

interface Props {
  title?: string;
  text?: string;
  icon?: React.ReactElement<any>;
}

export const DataEmpty: React.FunctionComponent<Props> = ({
  icon,
  title,
  text,
  children,
  ...rest
}) => (
  <Container {...rest}>
    {icon}
    {title && <StyledTitle>{title}</StyledTitle>}
    {text && <Subtitle>{text}</Subtitle>}
    {children}
  </Container>
);

const Container = styled(Column)`
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 0 70px;
  font-weight: bold;
`;

const StyledTitle = styled(Title)`
  text-align: center;
`;

const Subtitle = styled(Span)`
  font-size: 16px;
  line-height: 23px;
  opacity: 0.7;
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/core/data-empty.component.tsx